import { AnswerCarrousel, Content, ProductError, ProductErrorType } from '../../models';

export class CarousselTile {
  contents: Content[];
  answer: AnswerCarrousel;
  explanation?: string;
  selectedValue?: AnswerCarrousel;
  title: string;

  constructor(rawTile?: CarousselTile) {
    this.contents = (rawTile?.contents || []).map(c => new Content(c));
    this.title = rawTile?.title;
    this.answer = rawTile?.answer;
    this.explanation = rawTile?.explanation;
    this.selectedValue = rawTile?.selectedValue;
  }

  static validate(tile: CarousselTile, tileIndex?: number): ProductError[] {
    const primitivesError = ProductError.validatePrimitiveTypes(tile, ['answer']) //
      .map(error => ({ ...error, payload: { tileIndex } }));

    const contentsError: ProductError[] = [];
    const answersError = Content.validate(tile.answer, 0).map(error => {
      error.property = 'answer';
      error.payload.tileIndex = tileIndex;
      return error;
    });
    if (!tile.contents || !tile.contents.length) {
      contentsError.push({ type: ProductErrorType.MISSING, property: 'contents', payload: { tileIndex } });
    }
    tile.contents
      .map((c, i) => Content.validate(c, i))
      .reduce((flattened, subError) => flattened.concat(subError), [])
      .forEach(error => {
        error.payload.tileIndex = tileIndex;
        contentsError.push(error);
      });
    return [...primitivesError, ...contentsError, ...answersError];
  }
}

export class CarousselData {
  tiles: CarousselTile[];

  constructor(rawData?: CarousselData) {
    this.tiles = rawData ? rawData.tiles.map(t => new CarousselTile(t)) : [];
  }

  static validate(data: CarousselData): ProductError[] {
    const errors: ProductError[] = [];
    if (!data.tiles || data.tiles.length < 2) {
      errors.push({ type: ProductErrorType.NOT_ENOUGH_VALUE, property: 'tiles' });
    }
    data.tiles
      .map((tile, tileIndex) => CarousselTile.validate(tile, tileIndex))
      .forEach(subArray => errors.push(...subArray));
    return errors;
  }
}
